.ch{padding:0.5rem;}